import { render, staticRenderFns } from "./WAChannelSwitcher.vue?vue&type=template&id=788a8400&scoped=true"
import script from "./WAChannelSwitcher.vue?vue&type=script&lang=js"
export * from "./WAChannelSwitcher.vue?vue&type=script&lang=js"
import style0 from "./WAChannelSwitcher.vue?vue&type=style&index=0&id=788a8400&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788a8400",
  null
  
)

export default component.exports